{
    "filterConfig": {
      "filterFields": [ 
          {
              "name": "containerId.containerNo",
              "displayLabel": "Container No",
              "dataType": "STRING"
          },
          {
            "name": "cargoId.igmItemNo",
            "displayLabel": "IGM Item No",
            "dataType": "STRING"
          },
          {
              "name": "cargoId.chaId",
              "displayLabel": "CHA",
              "dataType": "STRING",
              "hasLookup": true,
              "searchConfig": {
                  "apiUrl": "v1/customers/list",
                  "filterByKeys": ["NAME_CONTAINS"],
                  "additionalFilters":[
                    {
                      "name": "IS_ACTIVE",
                      "alias": "active",
                      "operator": "EQ",
                      "value": ["true"]
                    },
                    {
                      "name": "CUSTOMER_TYPE_CONTAINS",
                      "alias": "customerType",
                      "operator": "IN",
                      "value": ["CHA"]
                    }
                  ],
                  "limit": 10,
                  "orderBy": { "name": "asc" },
                  "bindLabel": "name",
                  "bindValue": "id",
                  "displayColumns": [
                    { "key": "name", "header": "Name" }
                  ]
              }
          },
          {
            "name": "cargoId.accountHolder",
            "displayLabel": "Account Holder",
            "dataType": "STRING",
            "hasLookup": true,
            "searchConfig": {
                "apiUrl": "v1/customers/list",
                "filterByKeys": ["NAME_CONTAINS"],
                "additionalFilters":[
                  {
                    "name": "IS_ACTIVE",
                    "alias": "active",
                    "operator": "EQ",
                    "value": ["true"]
                  }
                ],
                "limit": 10,
                "orderBy": { "name": "asc" },
                "bindLabel": "name",
                "bindValue": "id",
                "displayColumns": [
                  { "key": "name", "header": "Name" }
                ]
            }
        },
        {
            "name": "releaseDocumentNo",
            "displayLabel": "Release Document No",
            "dataType": "STRING"
        },
        {
            "name": "holdDocumentNo",
            "displayLabel": "Hold Document No",
            "dataType": "STRING"
        }
      ]
    },

     "searchBarConfig": {
    "placeHolder": "Search container number",
    "filters": [
      {
        "name": "",
        "alias": "container_number"
      }
    ]
  },
  
    "tableConfig": {
      "name": "hold",
      "dbName": "hold",
      "columns": [
        {
          "fieldName": "containerNo",
          "displayName": "Container No",
          "dataType": "STRING"
        },
        {
          "fieldName": "igmItemNo",
          "displayName": "IGM Item No",
          "dataType": "STRING"
        },
        {
          "fieldName": "accountHolder",
          "displayName": "Account Holder",
          "dataType": "STRING"
        },
        {
          "fieldName": "cha",
          "displayName": "CHA",
          "dataType": "STRING"
        },
        {
          "fieldName": "holdCategoryLabel",
          "displayName": "Hold Type",
          "dataType": "STRING",
          "thStyleConfig": {
            "width": "60px"
          },
          "styleConfig": {
            "type": "badge",
            "styleProperties": {
              "display": "flex",
              "padding": "2px 8px",
              "alignItems": "center",
              "borderRadius": "16px",
              "textAlign": "center",
              "fontFamily": "Inter",
              "fontSize": "12px",
              "fontStyle": "normal",
              "fontWeight": "500",
              "lineHeight": "18px"
            },
            "conditions": [
              {
                "expression": "eq(value, 'Customs')",
                "styleProperties": {
                  "border": "1px solid var(--Pink-200, #FCCEEE)",
                  "background": "var(--Pink-50, #FDF2FA)",
                  "color": "var(--Pink-700, #C11574)"
                }
              },
              {
                "expression": "eq(value, 'Internal')",
                "styleProperties": {
                  "border": "1px solid var(--Indigo-200, #C7D7FE)",
                  "background": "var(--Indigo-50, #EEF4FF)",
                  "color": "var(--Indigo-800, #2D31A6)"
                }
              }
            ]
          }
        },
        {
          "fieldName": "holdIssuedByLabel",
          "displayName": "Hold Issued By",
          "dataType": "STRING",
          "thStyleConfig": {
            "width": "90px"
          },
          "styleConfig": {
            "type": "badge",
            "icon": "assets/icons/red_Dot.svg",
            "iconPosition": "left",
            "styleProperties": {
              "padding": "2px 6px",
              "gap": "4px",
              "borderRadius": "6px",
              "border": "1px solid var(--Gray-300, #D0D5DD)",
              "background": "var(--Base-White, #FFF)",
              "boxShadow": "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
              "color": "var(--Gray-700, #344054)",
              "fontFamily": "Inter",
              "fontSize": "12px",
              "fontStyle": "normal",
              "fontWeight": "500",
              "lineHeight": "18px"
            },
            "iconStyleProperties": {
              "width": "8px",
              "height": "8px"
            },
            "conditions": [
              {
                "expression": "eq(value, 'Finance')",
                "iconStyleProperties": {
                  "background": "#444CE7"
                }
              },
              {
                "expression": "eq(value, 'SIIB')",
                "iconStyleProperties": {
                  "background": "#F34199"
                }
              },
              {
                "expression": "eq(value, 'CCSP')",
                "iconStyleProperties": {
                  "background": "#F34199"
                }
              },
              {
                "expression": "eq(value, 'R&I')",
                "iconStyleProperties": {
                  "background": "#F34199"
                }
              },
              {
                "expression": "eq(value, 'DRI')",
                "iconStyleProperties": {
                  "background": "#F34199"
                }
              },
              {
                "expression": "eq(value, 'Operation')",
                "iconStyleProperties": {
                  "background": "#F34199"
                }
              }
            ]
          }
        },
        {
          "fieldName": "holdSubCategoryLabel",
          "displayName": "Hold Reason",
          "dataType": "STRING"
        },
        {
          "fieldName": "holdDocumentNo",
          "displayName": "Hold Document No",
          "dataType": "STRING"
        },
        {
          "fieldName": "holdDate",
          "displayName": "Hold Date",
          "dataType": "DATETIME"
        },
        {
          "fieldName": "releaseDocumentNo",
          "displayName": "Release Document No",
          "dataType": "STRING"
        },
        {
          "fieldName": "releaseDate",
          "displayName": "Release Date",
          "dataType": "DATETIME"
        },
        {
          "fieldName": "holdRemarks",
          "displayName": "Hold Remarks",
          "dataType": "STRING"
        },
        {
          "fieldName": "releaseRemarks",
          "displayName": "Release Remarks",
          "dataType": "STRING"
        }
      ]
    }
  }